import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TabItem, Tabs } from 'ypf-pas-general-ui-components';
import { BsFillBellFill } from 'react-icons/bs';

import Messages from '../../../ServiceRequest/DetailServiceRequest/TabsDetail/Messages/Messages';
import { proveedorNotificador, proveedorAdministrador } from '../../../../security/constantsRols';
import { checkRol } from '../../../../security';
import LocationWorkReports from '../../../../components/WorkReports/LocationWorkReports';
import useRequestDetailPermissions from '../../../../hooks/useRequestDetailPermissions';
import ButtonTab from '../../../ServiceRequest/DetailServiceRequest/TabsDetail/SolicitatedTab/ButtonTab';
import FilesDetailServiceRequest from '../../../ServiceRequest/DetailServiceRequest/TabsDetail/FilesDetailServiceRequest/FilesDetailServiceRequest'; // eslint-disable-next-line max-len
import { DetailRequestMonthly } from '../../../../utils/globalPropTypes';
import { statusEnum } from '../../../../utils/dataStatus';

import MonthlyRecordHistoryContainer from './MonthlyRecordHistory/MonthlyRecordHistoryContainer';
import MonthlyCommunicateToContainer from './MonthlyCommunicateTo/MonthlyCommunicateToContainer';
import MonthlyApproversTab from './MonthlyApproversTab/MonthlyApproversTab';
import MonthlyPteAutorizar from './MonthlyPteAutorizar/MonthlyPteAutorizar';

import './MonthlyTabsDetails.scss';

const MonthlyTabsDetails = ({ details, idStatus, requestData, getDetailsMonthlyHeader }) => {
  const [hasNewMessage, setHasNewMessage] = useState(false);
  const [updateNewMessage, setUpdateNewMessage] = useState(false);
  const isOyM = !!details?.operacion?.length;

  const { permissions } = useRequestDetailPermissions({
    notifyTo: details?.tipoNotificacionEnum,
    isASDS: false,
    isOyM
  });

  useEffect(() => {
    if (details) {
      setHasNewMessage(details.nuevoMensaje);
    }
  }, [details]);

  useEffect(() => {
    if (updateNewMessage) {
      setHasNewMessage(false);
    }
  }, [updateNewMessage]);

  const disabledEditStateCancelOrFinish =
    idStatus === statusEnum.finalizada || idStatus === statusEnum.cancelada;

  return (
    <>
      <Tabs className="mb-5" defaultActiveKey="parte de trabajo">
        <TabItem eventKey="parte de trabajo" title="PARTE DE TRABAJO">
          {details?.numeroContrato && details?.mes && permissions?.workPart ? (
            <LocationWorkReports
              IOPermissions={permissions?.typeAndObjectImputation}
              asignationType={details?.tipoAsignacion?.id}
              contractNumber={details?.numeroContrato}
              eventos={details?.eventos}
              filesPermissions={permissions.attachedFiles}
              getDetailsMonthlyHeader={getDetailsMonthlyHeader}
              hasLocations={details?.tieneUbicaciones || details?.tieneUbicacionesTecnicas}
              hasTechnicalLocations={details?.tieneUbicacionesTecnicas}
              idStatus={details?.estadoEnum}
              isOyM={isOyM}
              month={details?.mes}
              notificaPP={details?.contratoNotificaPP}
              number={details?.numero}
              requestData={requestData}
              workPartPermissions={permissions?.workPart}
            />
          ) : null}
        </TabItem>
        {details?.certificaEnYclick && permissions?.pendingAuthorization?.visualize && (
          <TabItem eventKey="autorizar" title="A AUTORIZAR">
            <MonthlyPteAutorizar
              contractNumber={details.numeroContrato}
              effectiveDate={details.fechaVigencia}
              id={details.id}
              serviceDetails={{ ...details, isOyM }}
            />
          </TabItem>
        )}
        <TabItem
          eventKey="mensaje"
          icon={hasNewMessage ? BsFillBellFill : null}
          placementIcon="right"
          styleIcon={{
            color: '#ff973d'
          }}
          title="MENSAJES"
        >
          <Messages
            idStatus={details?.estadoEnum}
            isMonthly
            messagePermissions={permissions.message || {}}
            setUpdateNewMessage={setUpdateNewMessage}
          />
        </TabItem>
        <TabItem eventKey="aprobadores" title="APROBADORES">
          <MonthlyApproversTab
            aprroverPermissions={permissions.approvers}
            details={details}
            idStatus={details?.estadoEnum}
            isOyM={isOyM}
          />
        </TabItem>
        <TabItem eventKey="comunicar" title="SEGUIMIENTO">
          <MonthlyCommunicateToContainer
            communicateToPermissions={permissions.communicateTo}
            details={details}
            isOyM={isOyM}
          />
        </TabItem>
        <TabItem eventKey="archivos" title="ARCHIVOS">
          <FilesDetailServiceRequest
            details={details}
            disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
            filesPermissions={permissions.attachedFiles}
            idStatus={details?.estadoEnum}
          />
        </TabItem>
        <TabItem
          disabled={checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)}
          eventKey={
            !(checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)) ? 'historial' : ''
          }
          title={
            !(checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)) ? 'HISTORIAL' : ''
          }
        >
          <MonthlyRecordHistoryContainer />
        </TabItem>
      </Tabs>
      <div className="d-flex justify-content-center align-item-center content-buttons-tabs">
        <ButtonTab
          idStatus={details?.estadoEnum}
          isMonthly
          key={`${details?.estadoEnum}${details?.numero}`}
          sdsName={details?.servicio.nombre}
          sdsNumber={details?.numero}
          showFinalizeButton={details?.botonFinalizarServicio}
        />
      </div>
    </>
  );
};

export default MonthlyTabsDetails;

MonthlyTabsDetails.propTypes = {
  details: DetailRequestMonthly.isRequired,
  idStatus: PropTypes.number.isRequired,
  requestData: PropTypes.shape({}).isRequired,
  getDetailsMonthlyHeader: PropTypes.func.isRequired
};
